import { Colors, Fonts, Metrics } from "Themes";
import { MainContainer, ProjectIcon } from "./styles";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";

import { AuthenticationSelectors } from "Redux/AuthenticationRedux";
import CreateProjectForm from "Forms/CreateProjectForm";
import EditProjectImagesForm from "Forms/EditProjectImagesForm";
import { GoRocket } from "react-icons/go";
import ProjectAvatarForm from "Forms/ProjectAvatarForm";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import { projectIconsAll } from "Assets/Constants";
import styled from "styled-components";

const Header = styled.h1`
  font-size: 30;
  color: ${Colors.mainColor};
  ...${Fonts.headerFont};
`;

class CreateProjectContainer extends Component {
  state = {
    projectCreated: false,
    resourcesCreated: false,
    resources: [],
    projectPublished: false
  };

  async componentDidMount() {
    await this.props.getResources();
  }

  componentDidUpdate(prevProps) {
    const { projectErrors, createdProject, resources } = this.props;

    // If the user projects have changed and there are no errors
    if (prevProps.createdProject !== createdProject && projectErrors === null) {
      this.setState({ projectCreated: true });
    }
    // If the resources have changed and there are no errors
    if (prevProps.resources !== resources && projectErrors === null) {
      this.setState({
        resources: resources
      });
    }
  }

  handleSubmit = async values => {
    const { createProject } = this.props;
    await createProject(values);
  };

  onResourcesSuccess = () => {
    this.setState({
      resourcesCreated: true,
      projectCreated: false
    });
  };

  onResourcesFailure = () => {
    window.alert("There was an error :(");
  };

  handleResourceSubmit = async values => {
    const { createdProject, addResources } = this.props;
    const resolve = {
      onSuccess: () => this.onResourcesSuccess(),
      onFailure: () => this.onResourcesFailure()
    };
    await addResources(
      {
        values,
        project: createdProject.id
      },
      resolve
    );
  };

  renderProjectIcons = () => {
    return projectIconsAll.map((icon, key) => {
      const ProjectIconTag = icon;
      return (
        <ProjectIcon
          key={key}
          onClick={() =>
            this.setState({
              selectedIcon: key
            })
          }
          selectedIcon={this.state.selectedIcon === key}
        >
          <ProjectIconTag fontSize={Metrics.iconFontSize} />
        </ProjectIcon>
      );
    });
  };

  onHandleProjectIconSubmitFailure = e => {
    window.alert("Oops...there was an error");
  };

  handleProjectIconSubmit = async icon => {
    const { updateProjectIcon, createdProject } = this.props;

    const resolve = {
      onSuccess: () => this.setState({ projectPublished: true }),
      onFailure: e => this.onHandleProjectIconSubmitFailure(e)
    };

    const data = {
      id: createdProject.id,
      projectIcon: icon
    };

    await updateProjectIcon(data, resolve);
  };

  render() {
    const {
      projectCreated,
      resourcesCreated,
      projectPublished
    } = this.state;
    const { history, user, createdProject } = this.props;
    return (
      <MainContainer>
        {projectPublished && (
          <SweetAlert
            success
            confirmBtnText="Continue"
            confirmBtnBsStyle="default"
            cancelBtnBsStyle="default"
            title="Project Published!"
            onConfirm={() => history.push(`${navRoutes.profile}/${user.id}`)}
          >
            Your has been published, make sure to keep it updated!
          </SweetAlert>
        )}

        {projectCreated ? (
          <>
            <Header>Add a Project Avatar</Header>
            <ProjectAvatarForm
              projectDetail={createdProject}
              history={history}
            />
          </>
        ) : resourcesCreated ? (
          <>
            <Header>Add a project icon</Header>
            <EditProjectImagesForm
              handleSubmit={icon => this.handleProjectIconSubmit(icon)}
              projectIcon={0}
              border
              buttonText={
                <>
                  Publish project <GoRocket />
                </>
              }
            />
          </>
        ) : (
          <>
            <Header>Start a Project</Header>
            <CreateProjectForm handleSubmit={this.handleSubmit} />
          </>
        )}
      </MainContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: AuthenticationSelectors.getUserDetails(state),
    userProjects: ProjectSelectors.getUserProjects(state),
    projectErrors: ProjectSelectors.getErrors(state),
    resources: ProjectSelectors.getResources(state),
    createdProject: ProjectSelectors.getCreatedProject(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createProject: data => dispatch(ProjectActions.createProjectRequest(data)),
    getResources: () => dispatch(ProjectActions.getResourcesRequest()),
    addResources: (data, resolve) =>
      dispatch(ProjectActions.addResourcesRequest(data, resolve)),
    updateProjectIcon: (data, resolve) =>
      dispatch(ProjectActions.updateProjectIconRequest(data, resolve))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateProjectContainer);
